import { Box, Text } from "@mantine/core"

import { Label } from "../../atoms/Label/Label"
import { LabelWithTooltip } from "../LabelWithTooltip/LabelWithTooltip"
import { Loader } from "../Loader/Loader"

export type BuildLabelProps = {
  label: React.ReactNode
  isLoading?: boolean
  required?: boolean
  toolTip?: string
}
export const buildLabel = ({
  label,
  isLoading,
  required,
  toolTip,
}: BuildLabelProps) => {
  if (!isLoading && !required) return <Label label={label} size="sm" />

  return (
    <Box display="flex">
      {toolTip && typeof label === "string" ? (
        <LabelWithTooltip label={label} hoverHelperText={toolTip} size="sm" />
      ) : (
        label
      )}
      {required && (
        <Text span c="var(--mantine-color-error)">
          *
        </Text>
      )}
      {isLoading && <Loader type="oval" size="xs" ml="xs" />}
    </Box>
  )
}
